import '../base';

// Objects & Web Components
import '../objects/web-share-wrapper';
import '../objects/modal';

// Global components (Static & NOT dynamic OS2 sections)\
import '../objects/content/ReadMore';
import '../objects/product/product-thumbnail';
import '../objects/pagination';
import '../objects/price-lookup';

import '../sections/carousel/carousel-section';
import '../sections/cart/Cart';
import '../sections/cart/CartDrawer';
import '../sections/cart/CartNote';
import '../sections/cart/CartQuantitySelector';
import '../sections/ProductsCarousel';
import '../sections/PinnedImages';

//Templates
import '../template/Product';
import '../template/wishlist';
import '../template/customers/LoginRegister';

// Global components (Static & NOT dynamic OS2 sections)
import '../components/navigation/header';

// Customiser
import '../components/size-picker';
import '../customiser/customiser-engine';

// Tools
import '../tools/responsive-video';
import '../objects/content/scrollbar';

// Let CSS know JS is available
document.documentElement.classList.remove('js-unavailable');
document.documentElement.classList.add('js-available');

// Disable zoom on iphone to prevent text fields from zooming in.
if(navigator.userAgent.indexOf('iPhone') > -1 ) {
  document.querySelector("[name=viewport]")?.setAttribute("content","width=device-width, initial-scale=1, maximum-scale=1");
}